import Decimal from 'decimal.js';
import { fromDateStampObject } from "../time";
import { makeResponse, make, makePeriod, makeBilledStage } from "./makers";
export function fromResponseDTO(responseDto) {
  const result = makeResponse();
  Object.entries(responseDto).forEach(_ref => {
    let [serviceId, dto] = _ref;
    result[serviceId] = fromDTO(dto);
  });
  return result;
}
function fromDTO(dto) {
  var _dto$billingStages;
  return make(dto.billableState, dto.periods.map(fromBillingPeriodDTO), fromDateStampObject(dto.minDate), fromDateStampObject(dto.maxDate), new Decimal(dto.billedAmount), ((_dto$billingStages = dto.billingStages) === null || _dto$billingStages === void 0 ? void 0 : _dto$billingStages.map(makeBilledStage)) || []);
}
function fromBillingPeriodDTO(dto) {
  return makePeriod(fromDateStampObject(dto.startDate), fromDateStampObject(dto.endDate), new Decimal(dto.billedQuantity), new Decimal(dto.scheduledQuantity));
}